import React from 'react';
import { Form } from 'antd';
import CardRadioGroup from '../../components/CardRadioGroup';
import s from '../../s.module.less';
import sc from './s.module.less';

const AlertIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" fill="currentColor" />
        <path d="M12 10v3.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16.8" r="1.1" fill="#fff" />
    </svg>
);

// Step 7 — Clearinghouse connection：switch / keep 单选（默认 switch，实际可选）
export default function StepClearinghouse() {
    return (
        <>
            <div className={sc.amber}>
                <AlertIcon />
                <div className={sc.amberBody}>
                    Routing remittances through our clearinghouse improves visibility into{' '}
                    <strong>insurance reimbursement</strong> and helps us <strong>track actual disbursement</strong>{' '}
                    (what hit your bank versus what payers adjudicated). When those do not line up, we can troubleshoot
                    faster with fuller context.
                </div>
            </div>
            <div className={s.wizSection} data-wiz-section>
                <Form.Item name={['clearinghouse', 'choice']} initialValue="switch" noStyle>
                    <CardRadioGroup
                        options={[
                            {
                                value: 'switch',
                                title: "Yes, switch to Klarity's clearinghouse",
                                recommended: true,
                                desc: 'We will have full visibility into your payments. This is the best option if you want proactive help tracking payment timing, amounts, and payer adjustments.',
                            },
                            {
                                value: 'keep',
                                title: 'No, keep my current clearinghouse',
                                desc: 'Your existing setup stays the same. We still manage your claims, but we may have limited visibility into when and how payers pay you.',
                            },
                        ]}
                    />
                </Form.Item>
            </div>
        </>
    );
}
